import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

export const StackBlock = styled(Stack)(({ theme }) => ({
  padding: 8,
  border: "none",
  borderRadius: 13,
  [theme.breakpoints.up("sm")]: {
    marginTop: 0,
    marginLeft: 6,
    marginBottom: 0,
  },
  [theme.breakpoints.down("md")]: {
    marginTop: 6,
    marginBottom: 6,
  },
  [theme.breakpoints.up("md")]: {
    marginTop: 0,
    marginLeft: 6,
    marginBottom: 0,
  },
}));

export const StackBlockTitle = styled(Stack)(({ theme }) => ({
  padding: 8,
  alignItems: "center",
  marginBottom: 8,
}));

export const BlockTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  letterSpacing: 1.2,
}));

export const StackLine = styled(Stack)(({ theme }) => ({
  padding: 8,
  alignItems: "center",
  transition: "background-color 0.3s",
  "&:hover": {
    backgroundColor: grey["100"],
  },
}));

export const StackLink = styled(Stack)(({ theme }) => ({
  padding: 4,
  borderRadius: 13,
  backgroundColor: grey["200"],
  "&:hover": {
    backgroundColor: "#f2f2f2",
  },
}));

export const HistoryReportGroupStackPrint = styled(Stack)(({ theme }) => ({
  padding: 2,
  borderWidth: 1,
  borderRadius: 6,
  borderColor: grey["500"],
  borderStyle: "solid",
  "@media print": {
    padding: 0,
    borderColor: grey["900"],
  },
}));
